import { render, staticRenderFns } from "./AccessDeniedBlock.vue?vue&type=template&id=076abb5b&scoped=true"
var script = {}
import style0 from "./AccessDeniedBlock.vue?vue&type=style&index=0&id=076abb5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076abb5b",
  null
  
)

export default component.exports